  <script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import ContactsActiveFiltersPreview from 'dashboard/components-next/Contacts/ContactsHeader/components/ContactsActiveFiltersPreview.vue';
import PaginationFooter from 'dashboard/components-next/pagination/PaginationFooter.vue';

const props = defineProps({
  showPaginationFooter: { type: Boolean, default: true },
  currentPage: { type: Number, default: 1 },
  totalItems: { type: Number, default: 100 },
  itemsPerPage: { type: Number, default: 15 },
  
  activeSegment: { type: Object, default: null },
  hasAppliedFilters: { type: Boolean, default: false },
  isFetchingList: { type: Boolean, default: false },
});

const emit = defineEmits([
  'update:currentPage',
  'clearFilters',
]);

const route = useRoute();

const isNotSegmentView = computed(() => {
  return route.name !== 'contacts_dashboard_segments_index';
});

const isLabelView = computed(() => {
  return route.name === 'contacts_dashboard_labels_index';
});

// Forward pagination changes to parent
const updateCurrentPage = (page) => {
  emit('update:currentPage', page);
};

</script>

<template>
  <section class="flex w-full gap-4 justify-evenly">
    <div class="flex flex-col w-full transition-all duration-300">
      <main class="flex-1 rounded-lg">
        <div class="w-full mx-auto">
          <ContactsActiveFiltersPreview
            v-if="
              (hasAppliedFilters || !isNotSegmentView) &&
              !isFetchingList &&
              !isLabelView
            "
            :active-segment="activeSegment"
            @clear-filters="emit('clearFilters')"
          />
          <slot name="default" />
        </div>
      </main>
      
      <!-- Fixed Pagination Footer (desktop) -->
      <div
        v-if="showPaginationFooter"
        class="hidden xl:block fixed bottom-3 left-0 right-0 z-40 xl:pl-64"
      >
        <div class="flex justify-center">
          <PaginationFooter
            :current-page="currentPage"
            :total-items="totalItems"
            :items-per-page="itemsPerPage"
            @update:currentPage="updateCurrentPage"
          />
        </div>
      </div>
    </div>
  </section>
</template>